import * as Sentry from "@sentry/react";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { APIProvider } from "@vis.gl/react-google-maps";
import { Toaster } from "sonner";
import ErrorBoundary from "../components/error-boundary";
import NotFoundPage from "../components/ui/not-found-page";

export const Route = createRootRouteWithContext()({
  component: () => {
    return (
      <ErrorBoundary>
        <APIProvider
          apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
          onError={(error) => {
            Sentry.captureException(error, {
              tags: { component: "APIProvider", mapLoadFailure: "true" },
            });
          }}
        >
          <div className="flex min-h-screen flex-col">
            <Outlet />
          </div>
        </APIProvider>
        <TanStackRouterDevtools />
        <Toaster />
      </ErrorBoundary>
    );
  },
  notFoundComponent: NotFoundPage,
});
